import { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { fmtIDR } from "../lib/format";
import { Smartphone, Loader2, Plus, Trash2, Save } from "lucide-react";
import { toast } from "sonner";

const LABELS = { PULSA: "Pulsa", TELE: "Telegram Premium" };

export default function Products() {
  const [catalog, setCatalog] = useState([]);
  const load = () => api.get("/products").then((r) => setCatalog(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-2">
        <Smartphone className="h-6 w-6 text-[#EAB308]" />
        <h1 className="font-head text-2xl font-bold">Produk (Harga Tetap)</h1>
      </div>
      <p className="text-sm text-[#64748B]">Atur daftar harga Pulsa & Telegram Premium. Harga = yang dibayar customer (masuk rupiah). Cost = modal Anda (untuk hitung profit).</p>

      {catalog.map((cat) => (
        <ProductTable key={cat.type} cat={cat} onSaved={load} />
      ))}
    </div>
  );
}

function ProductTable({ cat, onSaved }) {
  const [items, setItems] = useState(cat.items.map((i) => ({ ...i })));
  const [loading, setLoading] = useState(false);

  const update = (idx, field, val) => setItems(items.map((it, i) => (i === idx ? { ...it, [field]: val } : it)));
  const addRow = () => setItems([...items, { label: "", price_idr: "", cost_idr: "" }]);
  const delRow = (idx) => setItems(items.filter((_, i) => i !== idx));

  const save = async () => {
    setLoading(true);
    try {
      const payload = { items: items.filter((i) => i.label).map((i) => ({ label: i.label, price_idr: String(i.price_idr || 0), cost_idr: String(i.cost_idr || i.price_idr || 0) })) };
      await api.put(`/products/${cat.type}`, payload);
      toast.success(`${LABELS[cat.type]} disimpan`);
      onSaved();
    } catch (e) { toast.error(apiError(e)); } finally { setLoading(false); }
  };

  return (
    <div className="nnx-card p-4" data-testid={`product-table-${cat.type}`}>
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-head font-bold text-lg">{LABELS[cat.type]}</h2>
        <div className="flex gap-2">
          <button onClick={addRow} className="btn-outline text-sm flex items-center gap-1" data-testid={`add-item-${cat.type}`}><Plus className="h-4 w-4" /> Item</button>
          <button onClick={save} disabled={loading} className="btn-gold text-sm flex items-center gap-1" data-testid={`save-products-${cat.type}`}>{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Simpan</button>
        </div>
      </div>
      <div className="space-y-2">
        <div className="grid grid-cols-12 gap-2 text-[10px] uppercase tracking-widest text-[#64748B] px-1">
          <div className="col-span-3">List</div><div className="col-span-3">Harga (IDR)</div><div className="col-span-3">Cost (IDR)</div><div className="col-span-2">Margin</div><div className="col-span-1"></div>
        </div>
        {items.map((it, idx) => (
          <div key={idx} className="grid grid-cols-12 gap-2 items-center">
            <input className="nnx-input col-span-3 text-sm" value={it.label} onChange={(e) => update(idx, "label", e.target.value)} placeholder="cth $1.00" data-testid={`item-label-${cat.type}-${idx}`} />
            <input className="nnx-input col-span-3 text-sm mono" inputMode="decimal" value={it.price_idr} onChange={(e) => update(idx, "price_idr", e.target.value)} data-testid={`item-price-${cat.type}-${idx}`} />
            <input className="nnx-input col-span-3 text-sm mono" inputMode="decimal" value={it.cost_idr} onChange={(e) => update(idx, "cost_idr", e.target.value)} data-testid={`item-cost-${cat.type}-${idx}`} />
            <div className={`col-span-2 mono text-xs font-semibold ${(Number(it.price_idr || 0) - Number(it.cost_idr || it.price_idr || 0)) >= 0 ? "text-emerald-400" : "text-rose-400"}`} data-testid={`item-margin-${cat.type}-${idx}`}>{fmtIDR(Number(it.price_idr || 0) - Number(it.cost_idr || it.price_idr || 0))}</div>
            <button onClick={() => delRow(idx)} className="col-span-1 text-rose-400 hover:text-rose-300 flex justify-center" data-testid={`del-item-${cat.type}-${idx}`}><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
